<template>
  <al-card :title="signInTitle" size="lg" role="main">
    <div v-if="checkingSso" class="sso-loading">
      <al-loading size="md"></al-loading>
    </div>
    <form v-else id="login-form" @submit.prevent="login">
      <al-input
        v-model="email.value"
        :placeholder="email.placeholder"
        type="email"
        :state="email.error ? false : null"
        :message="email.errorMessage"
      ></al-input>
      <al-input
        v-model="password.value"
        :placeholder="password.placeholder"
        type="password"
        :state="password.error ? false : null"
        :message="password.errorMessage"
      ></al-input>
      <al-button type="submit">
        <span v-if="!loading"><Localization message="sign-in-button" /></span>
        <al-loading v-if="loading" size="sm"></al-loading>
      </al-button>
      <div class="alert-wrapper">
        <al-alert v-if="error" type="error">
          <Localization :message="error" />
        </al-alert>
      </div>
      <al-link isSmall href="/remind">
        <Localization message="sign-in-forgot-password" />
      </al-link>
    </form>
  </al-card>
</template>

<script>
import {
  AlInput,
  AlCard,
  AlButton,
  AlAlert,
  AlLoading,
  AlLink,
} from "almendra-components";
import { Localization, Translator } from "@agyletime/wfm-vue-common";

export default {
  name: "LoginForm",
  components: {
    AlInput,
    AlCard,
    AlButton,
    AlAlert,
    AlLoading,
    AlLink,
    Localization,
  },
  data() {
    const translator = Translator.getTranslator(this, this.onLanguageChange);
    return {
      translator,
      email: {
        value: "",
        error: false,
        errorMessage: "",
        placeholder: translator("email"),
      },
      password: {
        value: "",
        error: false,
        errorMessage: "",
        placeholder: translator("password"),
      },
      error: "",
      loading: false,
      checkingSso: true,
      signInTitle: translator("sign-in-title"),
    };
  },
  async created() {
    if (window.location.pathname.startsWith("/admin")) {
      this.checkingSso = false;
      return;
    }
    try {
      const baseUrl =
        window.environmentData && window.environmentData.apiGatewayBaseUrl;
      if (baseUrl) {
        const returnTo = new URLSearchParams(window.location.search).get(
          "returnTo"
        );
        const url = returnTo
          ? `${baseUrl}/authorization/sso-redirect?returnTo=${encodeURIComponent(
              returnTo
            )}`
          : `${baseUrl}/authorization/sso-redirect`;
        const response = await fetch(url);
        if (response.ok) {
          const body = await response.json();
          if (body.data && body.data.redirectUrl) {
            window.location.href = body.data.redirectUrl;
            return;
          }
        }
      }
    } catch (e) {
      // SSO check failed — fall through to show normal login form
    }
    this.checkingSso = false;
  },
  methods: {
    onLanguageChange() {
      this.setMessages();
    },
    setMessages() {
      this.signInTitle = this.translator("sign-in-title");
      this.email.placeholder = this.translator("email");
      this.password.placeholder = this.translator("password");

      this.email.errorMessage = this.email.error
        ? this.translator("email-required")
        : "";
      this.password.errorMessage = this.password.error
        ? this.translator("password-required")
        : "";
    },
    validate() {
      let valid = true;

      if (!this.email.value) {
        this.email.error = true;
        valid = false;
      } else {
        this.email.error = false;
      }

      if (!this.password.value) {
        this.password.error = true;
        valid = false;
      } else {
        this.password.error = false;
      }

      this.setMessages();
      return valid;
    },
    async login() {
      if (!this.validate()) {
        return;
      }

      try {
        this.loading = true;
        this.error = "";
        const result = await fetch(`/loginajax`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: this.email.value,
            password: this.password.value,
          }),
        });

        if (result.status === 200) {
          window.location = "/";
          return;
        }

        const data = await result.json();
        this.error = data.message;
      } catch (e) {
        console.log(e);
        this.error = "unknown-error";
      } finally {
        this.loading = false;
      }
    },
  },
  destroyed() {
    Translator.removeLanguageChangeListener(this);
  },
};
</script>

<style scoped>
.card {
  width: 100%;
}

button {
  width: 100%;
}
form {
  text-align: center;
}
form > * {
  text-align: initial;
  margin-bottom: 1rem;
}

/* Fix Misalignment of components due to padding */
.alert-wrapper {
  padding-right: 4px;
}

.dr-input >>> input {
  height: 1.75rem;
}

.sso-loading {
  text-align: center;
  padding: 2rem;
}
</style>
